export default __webpack_public_path__ + "static/media/bohdan.a6992a22.jpg";